/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * active_total object
 * @export
 * @interface GetFwLeaderboardsCharactersActiveTotalActiveTotal1
 */
export interface GetFwLeaderboardsCharactersActiveTotalActiveTotal1 {
    /**
     * Amount of victory points
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersActiveTotalActiveTotal1
     */
    amount?: number;
    /**
     * character_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsCharactersActiveTotalActiveTotal1
     */
    characterId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCharactersActiveTotalActiveTotal1 interface.
 */
export function instanceOfGetFwLeaderboardsCharactersActiveTotalActiveTotal1(value: object): value is GetFwLeaderboardsCharactersActiveTotalActiveTotal1 {
    return true;
}

export function GetFwLeaderboardsCharactersActiveTotalActiveTotal1FromJSON(json: any): GetFwLeaderboardsCharactersActiveTotalActiveTotal1 {
    return GetFwLeaderboardsCharactersActiveTotalActiveTotal1FromJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersActiveTotalActiveTotal1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCharactersActiveTotalActiveTotal1 {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'characterId': json['character_id'] == null ? undefined : json['character_id'],
    };
}

export function GetFwLeaderboardsCharactersActiveTotalActiveTotal1ToJSON(json: any): GetFwLeaderboardsCharactersActiveTotalActiveTotal1 {
    return GetFwLeaderboardsCharactersActiveTotalActiveTotal1ToJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersActiveTotalActiveTotal1ToJSONTyped(value?: GetFwLeaderboardsCharactersActiveTotalActiveTotal1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'character_id': value['characterId'],
    };
}

